import { Button } from "@material-ui/core";
import FileSaver from "file-saver";
import React, { createRef } from "react";
import { Route } from "react-router";
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { base64ToBlob, toBase64 } from "../../utils/FileUtils";
import './MultiproductPage.css';
import $ from 'jquery';
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import TrashIcon from '../../resources/wrappers/TrashIcon';
import { UploadFileRequest } from "../../models/UploadFileRequest";
import { IUploadFileResponse } from "../../models/UploadFileResponse";
import { HintDialog } from "./HintDialog";
import { ErrorDialog } from "./ErrorDialog";

export class MultiproductPage extends React.Component<any,any> {
    private inputFileRef: any;
    constructor(props: any){
        super(props);

        this.state = {
            buttonDisabled: true,
            showHintsDialog: false,
            fileTypeError: false,
            fileDimensionError: false,
            fileNotUpload: true,
            uploadedFile: undefined,
            resultError: false,
            notValidSheet: false,
            errors: undefined,
            showErrorDialog: false
        }

        this.dragEnter = this.dragEnter.bind(this);
        this.dragLeave = this.dragLeave.bind(this);
        this.dragOver = this.dragOver.bind(this);
        this.fileDrop = this.fileDrop.bind(this);

        this.inputFileRef = createRef();
        this.handleFileSelected = this.handleFileSelected.bind(this);
        this.handleClickOnUploadArea = this.handleClickOnUploadArea.bind(this);
    }

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto');
    }

    private downloadTemplate(){
        // download template...
        MposWebPortalApi.getInstance().getTemplateFile().subscribe((response) => {
            let fileData = response.fileData;
            let blob = base64ToBlob(fileData, 'application/vnd.ms-excel;charset=utf-8');
            let fileName = 'mpos_catalogo_prodotti_template.xls';
            FileSaver.saveAs(blob, fileName);
        }, () => {
            // show error page
            this.props.history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante il download del file",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "MultiproductPage", operation: "downloadTemplate" }
            })
        });
    }

    private uploadFile(history: any){
        // Convert file to base64
        toBase64(this.state.uploadedFile).then((result) => {
            let base64String = result;
            if(base64String !== undefined){
                //@ts-ignore
                let sanitized = base64String.split(',')[1];
                let fileExt = this.state.uploadedFile.name.split('.').pop();
                let request = new UploadFileRequest(sanitized, fileExt);
                MposWebPortalApi.getInstance().uploadFile(request).subscribe(() => {
                    // Success page
                    history.push('/result', {
                        isCatalog: true,
                        isMassiveImport: true,
                        isSuccess: true,
                        title: "Hai inserito nuovi prodotti nel tuo catalogo!",
                        button: "CREA NUOVO",
                        data: { from: "MultiproductPage", operation: "uploadFileSuccess", showComplete: true}
                    })
                }, (error) => {
                    if(error.status === 400){
                        let errorData: IUploadFileResponse = error.data;
                        if(errorData !== undefined){
                            let errorCode = errorData.statusCode;
                            if(errorCode === "4001"){
                                this.deleteFile();
                                this.setState({resultError: true});
                                this.setState({notValidSheet: true});
                                this.setState({errors: undefined});
                            } else {
                                let errorsCause = errorData.errorsCause;
                                if(errorsCause !== undefined && errorsCause.length > 0){
                                    this.deleteFile();
                                    this.setState({resultError: true});
                                    this.setState({notValidSheet: false});
                                    this.setState({errors: errorsCause});
                                } else {
                                    history.push('/result', {
                                        isSuccess: false,
                                        errorTitle: "Si è verificato un errore durante l'upload del file",
                                        message: "Riprova più tardi. Grazie per la pazienza",
                                        button: "TORNA AL CATALOGO",
                                        data: { from: "MultiproductPage", operation: "uploadFile" }
                                    })
                                }
                            }
                        } else {
                            history.push('/result', {
                                isSuccess: false,
                                errorTitle: "Si è verificato un errore durante l'upload del file",
                                message: "Riprova più tardi. Grazie per la pazienza",
                                button: "TORNA AL CATALOGO",
                                data: { from: "MultiproductPage", operation: "uploadFile" }
                            })
                        }
                    } else {
                        history.push('/result', {
                            isSuccess: false,
                            errorTitle: "Si è verificato un errore durante l'upload del file",
                            message: "Riprova più tardi. Grazie per la pazienza",
                            button: "TORNA AL CATALOGO",
                            data: { from: "MultiproductPage", operation: "uploadFile" }
                        })
                    }
                });
            } else {
                history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante l'upload del file",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL CATALOGO",
                    data: { from: "MultiproductPage", operation: "uploadFile" }
                })
            }
        }).catch(() => {
            // show error page
            history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante l'upload del file",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL CATALOGO",
                data: { from: "MultiproductPage", operation: "uploadFile" }
            })
        });
    }

    private showHintsDialog() {
        this.setState({showHintsDialog: true});
    }

    private closeHintsDialog(){
        this.setState({showHintsDialog: !this.state.showHintsDialog});
    }

    private showErrorDialog(){
        this.setState({showErrorDialog: true});
    }

    private closeErrorDialog(){
        this.setState({showErrorDialog: !this.state.showErrorDialog});
    }

    // Drag methods
    private dragOver(event: any){
        event.preventDefault();
        $('#mpos-drop-zone').addClass('multiproduct-drag-effect');
    }

    private dragEnter(event: any){
        event.preventDefault();
        $('#mpos-drop-zone').addClass('multiproduct-drag-effect');
    }

    private dragLeave(event: any){
        event.preventDefault();
        $('#mpos-drop-zone').removeClass('multiproduct-drag-effect');
    }

    // File from drag&drop
    private fileDrop(event: any){
        event.preventDefault();
        // Reset all states
        this.setState({fileTypeError: false});
        this.setState({fileDimensionError: false});
        this.setState({resultError: false});
        this.setState({notValidSheet: false});
        this.setState({errors: undefined});
        this.setState({uploadedFile: undefined});

        const file = event.dataTransfer.files[0];
        if(this.validateFile(file)){
            this.setState({fileNotUpload: false});
            this.setState({uploadedFile: file});
            this.setState({buttonDisabled: false});
        }
    }

    // File from click
    private handleFileSelected(event: any){
        const fileUploaded = event.target.files[0];
        if(this.validateFile(fileUploaded)){
            this.setState({fileNotUpload: false});
            this.setState({uploadedFile: fileUploaded});
            this.setState({buttonDisabled: false});
        }
    }

    private handleClickOnUploadArea(event: any){
        // Reset all states
        this.setState({fileTypeError: false});
        this.setState({fileDimensionError: false});
        this.setState({resultError: false});
        this.setState({notValidSheet: false});
        this.setState({errors: undefined});
        this.setState({uploadedFile: undefined});

        this.inputFileRef.current.click();
    }

    private validateFile(file: any): boolean {
        const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        // Check dimension
        let fileSizeInMiB = file.size / 1024 / 1024;
        if(fileSizeInMiB > 5){
            this.setState({fileTypeError: false});
            this.setState({fileDimensionError: true});
            return false;
        } else {
            if (validTypes.indexOf(file.type) === -1) {
                this.setState({fileTypeError: true});
                this.setState({fileDimensionError: false});
                return false;
            } else {
                return true;
            }
        }
    }

    private deleteFile(){
        this.setState({uploadedFile: undefined});
        this.setState({fileTypeError: false});
        this.setState({fileDimensionError: false});
        this.setState({buttonDisabled: true});
        this.setState({fileNotUpload: true});
    }

    private computeMargin(): number {
        let element = document.getElementById("multiproduct-hints-button");
        let footer = document.getElementById("desktop-footer-body");
        let bottom = element?.offsetTop! + 32;
        let top = footer?.offsetTop!;
        let difference = top - bottom + 56;
        return difference;
    }

    render(){
        return <div id="main-container-multiproduct">
            <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={"Crea prodotto"} showClose={true}
                        closePage={'/catalog'} />
            <div id="multiproduct-container-content">
                <p className={"multiproduct-title"}>Importa da file Excel</p>
                <p className={"multiproduct-subtitle"}>Per gestire tutti i prodotti in un’unica operazione scarica il template, compilalo e caricalo nel box qui sotto.</p>
                <p className={"multiproduct-download-template-button"} onClick={() => {this.downloadTemplate()}}>SCARICA TEMPLATE</p>
                <div className={"multiproduct-row"}></div>
            </div>
            {
                [this.state.fileNotUpload && <div id={"mpos-drop-zone"} 
                    className={(this.state.fileTypeError || this.state.fileDimensionError || this.state.resultError) ? "multiproduct-drop-zone-error" : "multiproduct-drop-zone"} onDragOver={this.dragOver} onDragEnter={this.dragEnter} onDragLeave={this.dragLeave} onDrop={this.fileDrop} 
                    onClick={this.handleClickOnUploadArea}>
                        <input type="file" style={{display: 'none'}} ref={this.inputFileRef} onChange={this.handleFileSelected}/>
                        <p className={"multiproduct-drop-zone-title"}>{"aggiungi un documento".toUpperCase()}</p>
                        <p className={"multiproduct-drop-zone-subtitle"}>{["Clicca o Trascina qui per caricare il file.",<br/>,"Dimensione max 5 MB formato xls o xlsx.",<br/>,"Numero max di fogli 1"]}</p>
                </div>, !this.state.fileNotUpload && <div className={"multiproduct-file-loaded-container"}>
                    <p className={"multiproduct-file-name"}>{this.state.uploadedFile !== undefined ? this.state.uploadedFile.name : ""}</p>
                    <div className={"multiproduct-trash-icon"} onClick={() => this.deleteFile()}>   
                        <TrashIcon width={'25px'} height={'25px'} fill={'#F9423A'}/>
                    </div>
                </div>]
            }
            {
                [(this.state.fileTypeError || this.state.fileDimensionError) && <p className={"multiproduct-input-error-desc"}>
                    Il formato del file non è valido.
                </p>, (this.state.resultError && !this.state.notValidSheet) && <p className={"multiproduct-upload-error-desc"}>
                    {["Non è stato possibile importare il file, a causa di errori", <br/>, "nella compilazione."]}
                </p>, 
                (this.state.resultError && this.state.notValidSheet) && <p className={"multiproduct-upload-error-desc"}>
                    Il file deve contenere al massimo un foglio di lavoro.
                </p>]
            }
            {
                this.state.resultError && !this.state.notValidSheet && <p className={"multiproduct-error-details"}>Vedi <span className={"multiproduct-error-details-link"}
                    onClick={() => this.showErrorDialog()}>dettaglio errori</span></p>
            }
            <p id={"multiproduct-hints-button"} className={"multiproduct-hints-button"} onClick={() => this.showHintsDialog()}>{"linee guida alla compilazione".toUpperCase()}</p>
            <div className={"multiproduct-button-next-container"} style={{marginTop: !this.state.fileNotUpload ? this.computeMargin() : 60}}>
                <Route render={({history}) => {
                    return <Button id={"multiproduct-button-next"} disabled={this.state.buttonDisabled} disableRipple disableTouchRipple onClick={() => {
                        this.uploadFile(history);
                    }}>AVANTI</Button>
                }}/>
            </div>
            {
                <HintDialog show={this.state.showHintsDialog} onClose={() => this.closeHintsDialog()} />
            }
            {
                <ErrorDialog show={this.state.showErrorDialog} onClose={() => this.closeErrorDialog()} errors={this.state.errors} />
            }
        </div>
    }
}